import React from 'react';

export const Loading = ({visible})=> {
    const style = {
        "width": "50px",
        "height": "50px",
        "backgroundColor": "#f4f7f9",
        "zIndex": "100000",
        "borderRadius": "50%",
        "border": "1px solid rgba(0, 0, 0, .2)",
        "borderRightColor": "#000",
        "WebkitAnimation": "fa-spin 1.2s infinite",
        "animation": "fa-spin 1.2s infinite",
        "margin": "auto",
        "WebkitTransition": "opacity 2s ease-in-out",
        "MozTransition": "opacity 2s ease-in-out",
        "MsTransition": "opacity 2s ease-in-out",
        "OTransition": "opacity 2s ease-in-out",
        "opacity": "1"
    };
    style.opacity = (visible) ?  "1" : "0";
    return (
        <div style={style}/>
    );
};




// WEBPACK FOOTER //
// ./src/components/Loading.js